import type { ModelBranch } from '@app/api/Branches';
import type { NBranches } from '@app/types';

export const adaptBranchToRedux = (data: ModelBranch) => {
  const {
    Address,
    City,
    CountryId,
    Id,
    ChainId,
    Name,
    OrganizationName,
    Timezone,
    IsDeleted,
    LegalEntityId,
    LegalEntity,
    NotificationsAddress,
    NotificationsPhone,
    Comment,
    InstructionFile,
    MoS,
    MoE,
    TuE,
    TuS,
    WeE,
    WeS,
    ThE,
    ThS,
    FrE,
    FrS,
    SaE,
    SaS,
    SuE,
    SuS,
    WarehouseId,
  } = data;

  const result: NBranches.Branch = {
    address: Address,
    chainId: ChainId,
    name: Name || '',
    isDeleted: IsDeleted,
    city: City || '',
    countryId: CountryId,
    id: Id,
    organizationName: OrganizationName || '',
    timezone: Timezone,
    legalEntityId: LegalEntityId,
    legalEntity: LegalEntity,
    notificationsAddress: NotificationsAddress,
    notificationsPhone: NotificationsPhone,
    comment: Comment || '',
    instructionFile: InstructionFile,
    moS: MoS,
    moE: MoE,
    tuE: TuE,
    tuS: TuS,
    weE: WeE,
    weS: WeS,
    thE: ThE,
    thS: ThS,
    frE: FrE,
    frS: FrS,
    saE: SaE,
    saS: SaS,
    suE: SuE,
    suS: SuS,
    warehouseId: WarehouseId,
  };

  return result;
};
